<script>
import Layout from '@layouts/main.vue'
import FeedbackBar from '@components/feedback-bar.vue'

export default {
  page: {
    title: 'Topic Details',
    meta: [{ name: 'description', content: 'The Topic Details page.' }],
  },
  components: { Layout, FeedbackBar },
  computed: {
    topicData() {
      return this.$store.getters['topics/filterTopicById']
    },
    unreadMessages() {
      return this.$store.getters['globals/unread']
    },
    platform() {
      return this.$store.getters['globals/platform']
    },
    isOldApp() {
      return this.$store.getters['globals/oldApp']
    },
    isRatingEnabled() {
      return this.$store.getters['globals/ratingEnabled']
    },
    sa2App() {
      return this.$store.getters['globals/sa2App']
    },
  },
  created() {
    this.$store.dispatch('topics/updateTopicId', this.$route.params.id)
  },
  methods: {
    isAndroid() {
      if (this.platform !== undefined)
        if (this.platform.includes('Android')) return true
      if (/Android/i.test(navigator.userAgent)) return true
      return false
    },
    contactUrl() {
      if (this.isOldApp) {
        location.replace('https://outfit7.com/game-support/#contact-anchor')
      } else {
        this.$router.push({ name: 'contact' })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div
      v-for="(item, index) in topicData"
      :key="index"
      :class="$style.container"
    >
      <h1>{{ item.title }}</h1>
      <div v-if="item" :class="$style.topiccontent" v-html="item.content"></div>
    </div>
    <md-button
      v-if="!sa2App"
      :class="[
        'chatbutton',
        'md-fab',
        'md-primary',
        isAndroid() ? 'android' : '',
        isRatingEnabled ? 'fbck' : '',
      ]"
      @click="contactUrl"
      @touch="contactUrl"
    >
      <svg class="md-icon" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24"><path fill="#ffffff" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" /></svg>
      <i
        :class="['badge', 'md-accent', unreadMessages > 0 ? 'show' : 'hide']"
        >{{ unreadMessages }}</i
      >
    </md-button>
    <FeedbackBar v-if="isRatingEnabled" :topic-id="$route.params.id" />
  </Layout>
</template>

<style lang="scss" module>
.container {
  padding-top: 20px;

  h1 {
    padding: 0 20px;
    line-height: 1.1em;
  }
}

.topiccontent {
  display: block;
  margin: 0 20px 10px 20px;

  a {
    overflow-wrap: break-word;
  }
}

.gotosupport {
  margin: 20px 20px 10px 20px;
  font-style: italic;
}
</style>
